import React, { useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Tooltip from "../pages/addentities/Tooltip.js";
import { Info } from "lucide-react";

const CalendarRangeInput = ({ label, name, startDate, endDate, onChange, onApplyRange, enableTime }) => {
  const dateInputRef = useRef(null);
  const [selectStart, setSelectStart] = useState(startDate);
  const [selectEnd, setSelectEnd] = useState(endDate);

  const applyRange = () => {
    if (onApplyRange) {
      onApplyRange();
    }
    dateInputRef.current.setOpen(false);
  };

  const cancelRange = () => {
    onChange({
      target: {
        name,
        value: { start: null, end: null },
      },
    });

    dateInputRef.current.setOpen(false);
  };

  const CalendarContainer = ({ className, children }) => {
    return (
      <div className={className}>
        {children}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            padding: "10px 15px",
            marginBottom:'-10px'
          }}
        >
          <button
            type="button"
            onClick={cancelRange}
            style={{
              display: "flex",
              width: "60px",
              height: "24px",
              padding: "12px 18px",
              justifyContent: "center",
              alignItems: "center",
              gap: "6px",
              borderRadius: "3px",
              border: "0.75px solid #000",
              background: "#FFF",
              cursor: "pointer",
              fontSize: "12px",
              color: "#000",
              textAlign: "center",
              fontFamily: "Montserrat",
              fontSize: "10px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "normal",
            }}
          >
            Cancel
          </button>

          <button
            type="button"
            className="btn btn-dark btn-sm"
            onClick={applyRange}
            style={{
              display: "flex",
              width: "60px",
              height: "24px",
              padding: "12px 18px",
              justifyContent: "center",
              alignItems: "center",
              gap: "6px",
              borderRadius: "3px",
              background: "#000",
              color: "#FFF",
              border: "none",
              color: "#FFF",
              textAlign: "center",
              fontFamily: "Montserrat",
              fontSize: "10px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "normal",
              border:'1px solid'
            }}
          >
            Apply
          </button>
        </div>
      </div>
    );
  };
  // ✅ Handle range select
  const handleDateChange = (dates) => {
    
    if (Array.isArray(dates)) {
      const [start, end] = dates;
      if(!end) {
        setSelectStart(start);
      }
      setSelectEnd(end);
      onChange({
        target: {
          name,
          value: { start, end },
        },
      });
    } else {
      // Time selection (single Date object)
      if (selectStart && !selectEnd) {
        // Update start time safely
        const updatedStart = new Date(selectStart);
        updatedStart.setHours(dates.getHours());
        updatedStart.setMinutes(dates.getMinutes());
        setSelectStart(updatedStart);
        startDate = updatedStart;
        const start = updatedStart;
        const end = null;
        onChange({
          target: {
            name,
            value: { start, end },
          },
        });
      } else if (selectStart && selectEnd) {
        // Update end time safely
        const updatedEnd = new Date(selectEnd);
        updatedEnd.setHours(dates.getHours());
        updatedEnd.setMinutes(dates.getMinutes());
        setSelectEnd(updatedEnd);
        endDate = updatedEnd;
        const start = selectStart;
        const end = updatedEnd;
        onChange({
          target: {
            name,
            value: { start, end },
          },
        });
      }
    }

    /* const [start, end] = dates;

    onChange({
      target: {
        name,
        value: { start, end },
      },
    });*/
  };

  // ✅ Clear range
  const clearDate = () => {
    onChange({
      target: {
        name,
        value: { start: null, end: null },
      },
    });
  };

  // ✅ Local formatter
  const formatLocalDate = (date) => {
    if (!date) return "";
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    let returnValue = `${yyyy}-${mm}-${dd}`;
    if (enableTime) {
      const hh = String(date.getHours()).padStart(2, "0");
      const min = String(date.getMinutes()).padStart(2, "0");
      returnValue += ` ${hh}:${min}`
    }
    return returnValue;
  };

  // ✅ Display logic
  /*const displayValue =
    selectStart && selectEnd
      ? `${formatLocalDate(selectStart)} - ${formatLocalDate(selectEnd)}`
      : selectStart
        ? formatLocalDate(selectStart)
        : "";*/
  const displayValue =
    startDate && endDate
      ? `${formatLocalDate(startDate)} - ${formatLocalDate(endDate)}`
      : startDate
        ? formatLocalDate(startDate)
        : "";

  // ✅ Dynamic class → today highlight remove after full range
  const calendarClass =
    startDate && endDate ? "custom-calendar range-selected" : "custom-calendar";

  return (
    <div className="info-inner">
      {label && (
        <label className="form-label d-flex align-items-center gap-1">
          {label}

          {name === "release_date" && (
            <Tooltip
              title="Released Date"
              body="The time when the SPU is released to the market"
            >
              <Info size={16} className="info-icon" />
            </Tooltip>
          )}
        </label>
      )}

      <div style={{ position: "relative" }}>
        <DatePicker
          ref={dateInputRef}
          selectsRange
          selected={endDate || startDate}
          startDate={startDate}
          endDate={endDate}
          onChange={handleDateChange}
          openToDate={startDate || endDate || new Date()}
          shouldCloseOnSelect={false}
          // dateFormat="yyyy-MM-dd HH:mm"
          dateFormat={enableTime ? "yyyy-MM-dd HH:mm" : "yyyy-MM-dd"}
          id={name}
          popperClassName={calendarClass}
          className="form-control common-input-all"
          onKeyDown={(e) => e.preventDefault()}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          placeholderText="Select date range"
          value={displayValue}
          calendarContainer={CalendarContainer}

          {...(enableTime && {
            showTimeSelect: true,
            timeFormat: "HH:mm",
            timeIntervals: 15,
            timeCaption: "Time"
          })}
        />

        {/* Clear Button */}
        {(startDate || endDate) && (
          <span
            onClick={clearDate}
            style={{
              position: "absolute",
              right: "40px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#6C757D",
              fontSize: "14px",
              fontWeight: "bold",
            }}
          >
            ×
          </span>
        )}

        {/* Calendar Icon */}
        <span
          onClick={() => dateInputRef.current.setFocus()}
          style={{
            position: "absolute",
            right: "12px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
          }}
          dangerouslySetInnerHTML={{
            __html: `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
  <path d="M6 1.5V4.5M12 1.5V4.5M2.25 7.5H15.75M3.75 3H14.25C15.078 3 15.75 3.672 15.75 4.5V15c0 .828-.672 1.5-1.5 1.5H3.75A1.5 1.5 0 0 1 2.25 15V4.5C2.25 3.672 2.922 3 3.75 3Z"
   stroke="#6C757D" stroke-width="2" stroke-linecap="round"/>
</svg>
`,
          }}
        />

        {/* Styles */}
        <style>{`
          .react-datepicker-wrapper,
          .react-datepicker__input-container {
            width: 100%;
          }

          input.form-control.common-input-all {
            padding-right: 50px !important;
            height: 40px;
          }

          .custom-calendar .react-datepicker {
            border-radius: 18px !important;
            padding: 18px;
            border: none;
            box-shadow: 0px 2px 15px rgba(0,0,0,0.15);
          }

          .custom-calendar .react-datepicker__header {
            background: transparent;
            border: none !important;
            padding-top: 10px;
            font-size: 16px;
            margin-top: -25px;
          }

          .custom-calendar .react-datepicker__current-month {
            display: none !important;
          }

          .custom-calendar select {
            border: none;
            background: transparent;
            border-radius: 6px;
            padding: 3px 6px;
            font-size: 14px;
            margin-top: -10px;
          }

          .custom-calendar .react-datepicker__day {
            width: 32px !important;
            height: 32px !important;
            line-height: 32px !important;
            display: inline-flex !important;
            align-items: center;
            justify-content: center;
          }

          /* remove keyboard fake highlight */
          .custom-calendar .react-datepicker__day--keyboard-selected {
            background: transparent !important;
            color: inherit !important;
          }

          /* hover */
          .custom-calendar .react-datepicker__day:hover {
            background-color: #FFEB00 !important;
            border-radius: 50% !important;
          }

          .custom-calendar .react-datepicker__day--in-selecting-range {
            background-color: #FFEB00 !important;
            color: #000 !important;
            border-radius: 50% !important;
            }

          /* ===== RANGE STYLES ===== */

          .custom-calendar .react-datepicker__day--range-start,
          .custom-calendar .react-datepicker__day--selected {
            background-color: #FFFEF0 !important;
            color: #000 !important;
            border-radius: 50% !important;
            border: 1px solid #FFEB00 !important;
          }

          .custom-calendar .react-datepicker__day--in-range {
            background-color: #FFFEF0 !important;
            color: #000 !important;
            border-radius: 50% !important;
          }

          .custom-calendar .react-datepicker__day--range-end {
            background-color: #FFEB00 !important;
            color: #000 !important;
            border-radius: 50% !important;
          }

          /* ===== TODAY — only when range NOT selected ===== */

          .custom-calendar:not(.range-selected)
            .react-datepicker__day--today {
              background: #FFEB00 !important;
              border-radius: 50% !important;
              font-weight: 600;
          }

          .custom-calendar .react-datepicker__navigation-icon::before {
            border-color: #333 !important;
          }

          input.form-control.common-input-all {
            color: #000 !important;
          }

            /* placeholder color */
          input.form-control.common-input-all::placeholder {
            color: #333 !important;
          }

        `}</style>
      </div>
    </div>
  );
};

export default CalendarRangeInput;
